// POST
export const ENDPOINTS_POST = {
	POST_REGISTER: "/customers/register",
	// treatments
	POST_TREATMENTS: "/treatments",
	// pets
	POST_PET: "/pets",
	// subscription
	POST_SUBSCRIPTION_EMAIL: "/subscription/email",
	// posts
	CREATE_POST: "/posts",
	// comment
	POST_COMMENT: "/comments",
	// report
	POST_REPORT: "/report",
	// payment
	POST_PAYMENT_CHARGE: "/payment/charge",
	// cart
	POST_CART: "/cart",
	// club
	POST_GROUP: "/group",
	// reaction
	POST_REACTION: "/reactions",
	// reminder
	POST_REMINDER: "/reminders",
	// document
	POST_DOCUMENT: "/documents",
	// user
	POST_USER: "/users",
	POST_CREATE_USER: "/user/create",
	POST_ACTIVATE_USER: "/user/activation",
	// walker-sitter
	POST_WALKER_SITTER: "/walker-sitters",
	// exercise
	POST_EXERCISE: "/pet-exercise",
	// pet orders
	POST_PET_ORDER: "/pet-orders/orders",
	// request pet orders
	POST_REQUEST_PET_ORDER: "/pet-orders/request-purchase",
	// latitude payment
	POST_PAYMENT_LATITUDE: "/latitude-pay-card/products/checkout",
	// latitude payment update status
	POST_UPDATE_PAYMENT_LATITUDE: "/latitude-pay-card/products/verify",
	POST_UPDATE_STATUS_LATITUDE: "/update-status/latitude",
	// store credit
	POST_STORE_CREDIT: "/store-credit",
	// address
	POST_ADDRESS: "/user/shipping/address",
	// latitude payment
	POST_PUBLIC_PAYMENT_LATITUDE: "/dog-purchase/request",
	POST_CHECKOUT_LATITUDE: "/checkout/latitude",
	POST_CHECKOUT_LATITUDE_INTEREST_FREE: "/checkout/latitude-interest-free",
	POST_PRODUCT_CHECKOUT_LATITUDE_INTEREST_FREE: "/latitude-pay-card/products/checkout",
	// contact us
	POST_CONTACT_US: "/contact-us",
	// Dog Purchase add pet
	DOG_PURCHASE_ADD_PET: "/dog-purchase/add-pet",
	// Register Breeder
	POST_REGISTER_BREEDER: "/breeders/register",
	// Puppy Sell
	POST_PUPPY_SELL_REQUEST: "/puppy-sell/request",
	// Puppy Sell Request Refund
	POST_PUPPY_SELL_REQUEST_REFUND: "/puppy-sell/request-refund",
	// Puppy Purchase Verify
	POST_PUPPY_PURCHASE_VERIFY: "/latitude-pay-card/puppy-purchase-verify",
	// Puppy Purchase Verify Plus
	POST_PUPPY_PURCHASE_VERIFY_PLUS: "/latitude-pay-plus/puppy-purchase-verify",
	// Latitude Pay Card Checkout
	POST_LATITUDE_PAY_CARD_CHECKOUT: "/latitude-pay-card/checkout",
	// Send Email
	POST_LATITUDE_SEND_EMAIL: "/latitude-pay/send-email",

	POST_VERIFY_LATITUDE: "/verify/latitude-interest-free",
	
	PUT_DEACTIVATE_USER: "/user/customer/deactivate-status",

	// Dam/Sire
	POST_DAM_SIRE: "/dam-sire",
	POST_DAM_SIRE_DOCUMENT: "/dam-sire/documents",
	POST_DAM_SIRE_DOCUMENTS_MULTIPLE: "/dam-sire/documents/multiple",

	// Mating
	POST_MATING_DETAILS: "/dam-sire/mating-details",

	// Mating and Cycle Dates
	POST_MATING_AND_CYCLE_DATES: "/dam-sire/mating-and-cycle-dates",

	// Litters
	POST_LITTERS: "/dam-sire/litters",

	// Waitlist
	POST_ALLOCATE_PUPPY: "/waitlist/allocate-puppy",
	GET_WAITLIST: "/waitlist",
	GET_PUPPIES_TO_ALLOCATE: "/waitlist/puppies-to-allocate",
	GET_ALLOCATED_PUPPY_DETAILS: "/waitlist/allocated-puppy",
	PUT_ALLOCATED_PUPPY_DETAILS: "/waitlist/allocated-puppy",
}

// PUT
export const ENDPOINTS_PUT = {
	// treatments
	PUT_TREATMENT: "/treatment-schedule",
	// notification
	PUT_NOTIFICATION: "/notification",
	// notification
	PUT_ALL_NOTIFICATIONS: "/notifications/customer",
	// users
	PUT_USER: "/user",
	// update pet
	PUT_PET: "/pet",
	// club
	PUT_CLUB: "/club",
	PUT_REPORT_CONTENT: "/report",
	// cart
	PUT_CART: "/cart",
	// order
	// /:orderId/cancel/:petId
	PUT_ORDER: "/order",
	// group
	PUT_GROUP: "/group",
	// reminder
	PUT_REMINDER: "/reminders",
	// document
	PUT_DOCUMENT: "/documents",
	// customers
	PUT_CUSTOMER: "/customers",
	// walker-sitter
	PUT_WALKER_SITTER: "/walker-sitters",
	// exercise
	PUT_EXERCISE: "/pet-exercise",
	//dog purchase
	PUT_DOG_PURCHASE: "/dog-purchase",
	//puppy sell
	PUT_PUPPY_SELL: "/puppy-sell",
	//breeder
	PUT_BREEDER: "/breeders",
	//puppy sell
	PUT_PUPPY_PURCHASE: "/puppy-purchase",

	// subscripition
	PUT_SUBSCRIPTION: "/subscription",

	// Dam/Sire
	PUT_DAM_SIRE: "/dam-sire",
	
	// Mating
	PUT_MATING_DETAILS: "/dam-sire/mating",

	// Ovulation / Gestation
	POST_OVULATION_GESTATION: "/ovulation-gestation",

	// dam/sire document
	PUT_DAM_SIRE_DOCUMENT: "/dam-sire/documents",

	// Mating and Cycle Dates
	PUT_MATING_AND_CYCLE_DATES: "/dam-sire/mating-and-cycle-dates",

	PUT_MATING_STATUS: "/dam-sire/mating/update-status",

	PUT_DAM_WHELP_DATE_AND_TYPE_OF_BIRTH: "/dam-sire/whelp-date-and-birth-type"
}

// PATCH

export const ENDPOINTS_PATCH = {
	// Post
	PATCH_POST: "/posts",
	// Comment
	PATCH_COMMENT: "/comments",
}

// GET
export const ENDPOINTS_GET = {
	// breeds
	GET_BREEDS: "/breeds",
	GET_BREEDERS: "/breeders",
	// users
	GET_LOGGED_IN_USER: "/users",
	// general info
	GET_BREED_INFO: "/breed/info",
	// treatments
	GET_TREATMENTS: "/treatments",
	GET_TREATMENT_SCHEDULE: "/treatment-schedule",
	// notifications
	GET_NOTIFICATION: "/notifications",
	// Bundle
	GET_BUNDLE: "/bundle",
	// Bundles
	GET_BUNDLES: "/bundles",
	GET_BUNDLES_PUBLIC_LIST: "/bundles/public/list",
	GET_BUNDLES_PUBLIC_LIST_PRODUCTS: "/bundles/public/products",
	GET_BUNDLES_PUBLIC_DETAILS: "/bundles/public/details",
	// brands
	GET_BRANDS: "/brands",
	// tracking
	GET_TRACKING: "/track/history",
	// Get pet by ID
	GET_PET_BY_ID: "/pet",
	// products
	GET_PRODUCT: "/product",
	GET_PRODUCTS: "/products",
	GET_PRODUCT_TYPE: "/product-types",
	// post
	GET_POSTS: "/posts",
	// Comment
	GET_COMMENTS: "/comments",
	// club
	GET_CLUB: "/club",
	GET_ADMIN_REPORTED: "/report",
	// subscription period
	GET_SUBSCRIPTION_PERIOD: "/subscription/period",
	GET_SUBSCRIPTION_TRACK: "/subscription/track",
	GET_SUBSCRIPTION_DETAILS: "/subscription",
	// cart
	GET_CART: "/cart",
	GET_PUBLIC_CART: "/public/cart",
	// transaction history
	GET_ORDER_LIST: "/order/customer",
	GET_CUSTOMER_DOG_ORDER_LIST: "/order/history/customer",
	GET_ORDER: "/order",
	GET_CUSTOMER_DOG_ORDER: "/order/dog",
	// default settings
	GET_DEFAULT_SETTINGS: "/default-settings",
	// group
	GET_GROUP: "/groups",
	// reaction
	GET_REACTION: "/reactions",
	// reminder
	GET_REMINDER: "/reminders",
	// document
	GET_DOCUMENT: "/documents",
	// pet weight
	GET_WEIGHT: "/pet-weights",
	// walker/sitter
	GET_WALKER_SITTER: "/walker-sitters",
	// exercise
	GET_EXERCISE: "/pet-exercise",
	// pet orders
	GET_PET_ORDERS: "/pet-orders/orders",
	// store credit
	GET_STORE_CREDIT: "/store-credit",
	// get pet order
	GET_PET_ORDER: "/pet-orders",
	GET_DOG_PURCHASE: "/dog-purchase",
	// address
	GET_ADDRESS: "/user/shipping/address",
	GET_DEFAULT_ADDRESSES: "/user/default/address",
	//puppy sell
	GET_PUPPY_SELL: "/puppy-sell",
	//puppy purchase
	GET_PUPPY_PURCHASE: "/puppy-purchase",
	//puppy purchased
	GET_PUPPY_PURCHASE_HISTORY: "/purchase-history",
	//latitude interest free
	GET_LATITUDE_INTEREST_FREE: "/latitude-interest-free",
	// puppy-packs
	GET_PUPPY_PACK: "/puppy-pack",
	GET_PUPPY_PACK_DETAILS: "/puppy-pack",
	// transaction history
	GET_SUBSCRIPTION_LIST: "/subscription/customer",

	// dam/sire
	GET_DAM_SIRE: "/dam-sire",
	GET_DAM_SIRE_MATING: "/dam-sire/mating/details",
	GET_DAM_SIRE_DOCUMENTS_LIST: "/dam-sire/documents",
	GET_DAM_SIRE_DOCUMENTS_LIST_PROGRESS: "/dam-sire/documents/progress",

	GET_DAM_WHELP_TYPES_AND_PREV_LITTERS: "/dam-sire/whelp-type-prev-litters-list",

	// Ovulation / Gestation
	GET_OVULATION_GESTATION: "/ovulation-gestation",
}

// DELETE
export const ENDPOINTS_DELETE = {
	// treatments
	DELETE_TREATMENT: "/treatment",
	// pet
	DELETE_PET: "/pet",
	// post
	DELETE_POST: "/posts",
	// comment
	DELETE_COMMENT: "/comments",
	// cart
	DELETE_CART: "/cart",
	// document
	DELETE_DOCUMENT: "/documents",
	// exercise
	DELETE_EXERCISE: "/pet-exercise",
	// pet order
	DELETE_PET_ORDER: "/pet-orders",
	// dog purchase cart
	DELETE_DOG_CART: "/dog-purchase/cart",
	// address
	DELETE_DEFAULT_ADDRESSES: "/user/default/address/delete",

	// dam/sire document
	DELETE_DAM_SIRE_DOCUMENT: "/dam-sire/documents",
}
